import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Text, { typeConstants, weightConstants } from '@gef-ui/components/atoms/Text/Text';
import CenteredButton from '@gef-ui/delegations/components/CenteredButton';
import { getMessage } from '@gef-ui/localization/messages';

import { Panel } from 'components';
import PAGES from 'constants/pages';

const IascError = () => {
	const navigate = useNavigate();
	const { state } = useLocation();
	const { canContinue = true, errMsgs = [], inputParams = {} } = state || {};

	useEffect(() => {
		document.title = getMessage(`common:gkcl${904}`);
	}, []);

	const handleClick = useCallback(() => {
		navigate('/');
	}, [navigate]);

	return (
		<div className="Delegations">
			<Panel screenId={PAGES.wrappersAndFallbacks.iascError.id}>
				<Text className="Text--mainTitle" type={typeConstants.PRIMARY} weight={weightConstants.MEDIUM}>
					{getMessage('iasErrors:pageTitle')}
				</Text>
				<div className="Section-group">
					<ul>
						{errMsgs.map((msg, i) => {
							return <li key={i}>{msg}</li>;
						})}
					</ul>
				</div>
				<br />
				<Text className="Text--mainTitle" type={typeConstants.PRIMARY} weight={weightConstants.MEDIUM}>
					{getMessage('iasErrors:pageInputs')}
				</Text>
				<div className="Section-group">
					<ul>
						{Object.entries(inputParams).map(([key, value]) => {
							return (
								<li key={key}>
									<strong>{key}</strong>: {value}
								</li>
							);
						})}
					</ul>
				</div>
				{canContinue && (
					<div className="Space--top">
						<CenteredButton label={getMessage('iasErrors:continueLabel')} onClick={handleClick} />
					</div>
				)}
			</Panel>
		</div>
	);
};

export default IascError;
